module.exports = __webpack_public_path__ + "img/eps.e263c46.svg";